import { render } from "./decision.vue?vue&type=template&id=2b7bb60a&scoped=true"
import script from "./decision.vue?vue&type=script&lang=js"
export * from "./decision.vue?vue&type=script&lang=js"

import "./decision.vue?vue&type=style&index=0&id=2b7bb60a&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7bb60a"]])

export default __exports__